import { AdminPanelHeaderProps } from './admin-panel-header-props';
import styled from 'styled-components';

export const AdminPanelHeader = styled.div<AdminPanelHeaderProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  padding: ${props => (props.noPadding ? null : '1rem 1rem 0')};
`;
